// export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
// export const LOGOUT = 'LOGOUT'


// export const loginSuccess = (userData) => ({
//   type: LOGIN_SUCCESS,
//   payload: userData,
// });
// Action types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'

// Action creators
export const loginSuccess = (userData) => ({
  type: LOGIN_SUCCESS,
  payload: userData,
})

export const logoutUser = () => ({
  type: LOGOUT,
})

